import { adminApi as api } from '@core/api/httpClient'
import apiEndpoints from '@core/config/apiEndpoints'
import _get from 'lodash/get'
import type { OrderItemDto, OrderOverviewMetricsDto } from './investorOverviewContracts'
import type { OrderItem, OrderOverviewMetrics } from '../types/investorOverviewTypes'
import { parseOrderItem, parseOrderOverviewMetrics } from './investorOverviewParser'

export const getOrderMetrics = async (investorId?: string): Promise<OrderOverviewMetrics> => {
  const { data } = await api.get(`${apiEndpoints.ORDERS}/metrics`, {
    params: { investor_id: investorId },
  })
  return parseOrderOverviewMetrics((data?.data ?? {}) as OrderOverviewMetricsDto)
}

export const getOrdersOverview = async (): Promise<OrderItem[]> => {
  const { data } = await api.get(`${apiEndpoints.ORDERS}/overview`)
  const rows = _get(data, 'data', []) as OrderItemDto[]
  return rows.map(parseOrderItem)
}
